import { render, staticRenderFns } from "./ac-kanban.vue?vue&type=template&id=56e5bbdb&scoped=true&"
import script from "./ac-kanban.vue?vue&type=script&lang=js&"
export * from "./ac-kanban.vue?vue&type=script&lang=js&"
import style0 from "./ac-kanban.vue?vue&type=style&index=0&id=56e5bbdb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56e5bbdb",
  null
  
)

export default component.exports